import React from "react";
import informationIcon from "../../assets/img/Information.svg";

const RadioTyped = ({
  answer,
  handleChange,
  error,
  question,
  options,
  name,
  info,
}) => {
  return (
    <div className="cus_form basic_question_box">
      <div className="custom_filed custom_basic">
        <div className="form-group">
          <label htmlFor={name} className="basic">
            {question}
            {info && (
              <img
                src={informationIcon}
                alt="Information"
                data-toggle="tooltip"
                data-placement="bottom"
                title={typeof info === "string" ? info : ""}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            )}
            {/* </a> */}
          </label>
          <ul>
            {options.map((option, index) => (
              <li key={index}>
                <input
                  type="radio"
                  id={option}
                  name={name}
                  value={option}
                  checked={answer === option}
                  onChange={handleChange}
                />
                <label htmlFor={option}>{option}</label>
              </li>
            ))}
          </ul>
          {error && (
            <p className="text-danger" style={{ marginTop: "5px" }}>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RadioTyped;
